import { useEffect, useState } from "react";
import Aside from "../../components/Aside";
import CustomDataTable from "../../components/CustomDataTable";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import ModalDBAdd from "./ModalDBAdd";
import { useCurrentAccount } from "../../hooks/useCurrentAccount";
import PieChart from "../../components/PieChart";
import { DBClientsService } from "../../services/DBClientsService";
import Button from "../../components/form-controls/Button";
import { AlertService } from "../../services/Alert";
import { useTranslation } from "react-i18next";
import useRequest from "../../hooks/useRequest";
import usePermission from "../../hooks/usePermission";

export default function BdClientsPage() {

    const { t }= useTranslation();
    const {call, isRequesting} = useRequest();
    const { account } = useCurrentAccount();
    const hasActionsAccess= usePermission('accounts_db.actions');
    const hasCreationAccess = usePermission('accounts_db.create');
    const [showModalDB, setShowModalDB] = useState(false)
    const [data, setData] = useState([])
    
    const [filterRangeDates, setFilterRangeDates] = useState({ start: null, end: null})

    const columns = [
        {
            name: t("bd-clients.name-column"),
            sortable: true,
            selector: row => row.name,
        },
        {
            name: t("bd-clients.total-entries"),
            sortable: true,
            center: true,
            selector: row => row.total_rows,
        },
        {
            name: t("bd-clients.overview"),
            sortable: false,
            center: true,
            cell: (row) => {            
                return  (
                    <PieChart 
                        datasetName='Resumen'
                        dataset={{
                            labels: [t("bd-clients.labels.new"),t("bd-clients.labels.uploaded"),t("bd-clients.labels.incorrect")],
                            data: [row.resume_base.contacts_new,row.resume_base.contacts_updated,row.resume_base.contacts_invalid],
                            backgroundColor: ['#f5ca99', '#0A595F', '#ed4c78'],
                        }}
                    />
                )

            }
        },
        {
            name: t("bd-clients.interactions"),
            sortable: false,
            center: true,
            cell: (row) => {            
                return  (
                    <PieChart 
                        datasetName='Interacciones'
                        dataset={{
                            labels: [t("bd-clients.labels.inbound"),t("bd-clients.labels.outbound"),t("bd-clients.labels.no-contact")],
                            data: [row.resume_contact.contacts_inbound,row.resume_contact.contacts_outbouns,row.resume_contact.contacts_pendient],
                            backgroundColor: ['#09a5be', '#0f458d', '#ed4c78'],
                        }}
                    />
                )

            }
        },
        {
            name: t("bd-clients.status"),
            sortable: true,
            cell: (row ) => {

                return row.status
                

                // return row.status ? (
                //     <span className="badge bg-soft-danger text-danger">
                //         <span className="legend-indicator bg-danger"></span> Inactiva
                //     </span>
                // ): (
                //     <span className="badge bg-soft-info text-info">
                //         <span className="legend-indicator bg-info"></span> Activa
                //     </span>
                // )
            }
        },
        {
            name: t("bd-clients.subaccount"),
            sortable: true,
            selector: row => row.sub_account,
        },
        {
            name: t("bd-clients.date"),
            sortable: true,
            selector: row => <p className="text-nowrap mb-0">{row.date}</p>,
        },        
        ...(hasActionsAccess ? [{
                name: t("bd-clients.actions"),
                sortable: false,
                center: true,
                cell: (row) => {
                    return (
                        <div className="btn-group" role="group">
                            <Button className="btn bg-soft-info-alternative btn-sm text-white-dark"  onClick={ () => downloadReport(row)} >
                                <i className="bi-download text-primary me-2 fs-4 fw-bold"></i> {t("bd-clients.download")}
                            </Button>
    
                            {/* <div className="btn-group">
                                <button type="button" className="btn btn-white btn-icon btn-sm dropdown-toggle dropdown-toggle-empty" data-bs-toggle="dropdown" aria-expanded="false"></button>
    
                                <div className="dropdown-menu dropdown-menu-end mt-1" >
                                    <button className="dropdown-item" onClick={() => handleStatusDB(row)}>
                                        { row.status ? 'Activar': 'Desactivar' }
                                    </button>
                                </div>
                            </div> */}
    
                        </div>
                    )
                }
        }]:[]),
    ];

    const handleCloseModal = async(refresh) => {
        if (refresh) {
            await getDBS();
        }

        setShowModalDB(false)
    }

    const downloadReport = async(db) => {
        const promise = async() => {
            const response = await DBClientsService.downloadReport(db.id)

            const blob = new Blob([response], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.setAttribute("download", `${db.name}.csv`);
            link.style.display = "none";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(url);
        }

        AlertService.toastLoading(promise(), 'Creando reporte...', 'Se generó correctamente el reporte', 'Ocurrió un error al generar el reporte, intenta nuevamente')
    }

    const handleStatusDB = async(db) => {
        const message =  `¿Estás seguro de querer ${db.status ? 'activar': 'desactivar'} esta base de clientes?`

        await AlertService.warning('Aviso', message, async () => {
            try {

                await DBClientsService.handleStatusDB({ status: db.status ? 0: 1, id_base_clients: db.id })
                await getDBS()

                AlertService.toastSuccess('Se cambió el estatus correctamente.')
            } catch (error) {
                console.error(error);
                AlertService.error('¡Error!', 'Ocurrió un error al cambiar el estatus de la base de clientes, intenta nuevamente')
            }
        });
    }

    const getDBS = async() => {
        if(filterRangeDates.start && filterRangeDates.end) {
            const start = filterRangeDates.start.format('YYYY-MM-DD')
            const end = filterRangeDates.end.format('YYYY-MM-DD')

            const { data } = await call(() => DBClientsService.getAll(account.id, start, end));
            setData(data)
        }
    }

    useEffect(() => {
        getDBS()
    }, [filterRangeDates])
    
    return (
        <>
            <Header />
            <Aside />

            <main id="content" role="main" className="main">

                <div className="content container-fluid">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm mb-2 mb-sm-0">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb breadcrumb-no-gutter">
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >{t("reports.operation-title")}</span></li>
                                        <li className="breadcrumb-item active" aria-current="page">{t("bd-clients.bd-title")}</li>
                                    </ol>
                                </nav>
                                <h1 className="page-header-title text-white-dark"><i className="bi-person-bounding-box text-primary  nav-icon"></i> {t("bd-clients.bd-title")}</h1>
                            </div>
                            {
                                hasCreationAccess ?
                                <div className="col-sm-auto">
                                    <button className="btn btn-primary btn-sm" onClick={() => setShowModalDB(true)}><i className="bi-plus-lg me-1"></i>{t("bd-clients.add-bd")}</button>
                                </div>
                                : null
                            }
                        </div>
                    </div>

                    <CustomDataTable
                        columns={columns}
                        data={data}
                        showDates
                        hideAccountsFilter
                        showExport={false}
                        isLoading={isRequesting}
                        onDatesChange={(range) => setFilterRangeDates(range)}
                        filter={(row, term) => {
                            if(!term) return true;

                            return (
                                `${row.name}`.match(new RegExp(`${term}`, 'i'))  || 
                                `${row.status}`.match(new RegExp(`${term}`, 'i'))  || 
                                `${row.sub_account}`.match(new RegExp(`${term}`, 'i'))  || 
                                `${row.total_rows}`.match(new RegExp(`${term}`, 'i')) 
                            )
                        }}
                    />

                    <ModalDBAdd 
                        show={showModalDB} 
                        onRequestClose={(refresh) => handleCloseModal(refresh)}
                    />
                    
                </div>
                <Footer />
            </main>
        </>
    )
}